// Core
import React from "react"

// Style
import styles from "./playBtn.module.scss"

// Imagery
import Play from "./images/play.inline.svg"

// Components
import { SlideMaskText } from "../slideMaskText"

const PlayBtn = ({ playing = false, event = null, text = null }) => {
  return (
    <button
      onClick={event}
      className={`${styles.play} ${playing ? styles.hidden : ""}`}
    >
      <Play />
      {text && <SlideMaskText text={text} />}
    </button>
  )
}

export default PlayBtn
